import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { getCurrentLocale } from '@probatix/common/translations'
import {
  getCoreDomain,
  customHeaders,
  authPatch,
} from '@probatix/common/services/services.helpers'
import {
  basePathPatients,
} from '@probatix/common/services/RTKServices/patientEvents/index.helpers'
import { User } from '@probatix/common/services/RTKServices/patients/index.model'
import { EXPIRY_OF_JWT_TOKEN_MINUTES } from '@probatix/common/config/app'
import LocalStorage from '@probatix/common/utils/localStorage'
import { EXPIRATION_TIME_JWT, JWT } from '@probatix/common/services/services.constants'

export const setJWT = (responseData) => {
  {
    if (responseData.token && null !== responseData.token!) {
      const expiry = Date.now() + 1000 * 60 * Number(EXPIRY_OF_JWT_TOKEN_MINUTES)
      LocalStorage.set(JWT, responseData.token)
      LocalStorage.set(EXPIRATION_TIME_JWT, expiry)
    }

    return responseData
  }
}

// Define a service using a base URL and expected endpoints
export const patientsApi = createApi({
  baseQuery: fetchBaseQuery({ baseUrl: getCoreDomain() }),
  endpoints: (builder) => ({
    deletePatients: builder.query<any, any>({
      query: () => ({
        headers: customHeaders(),
        method: 'DELETE',
        url: `${basePathPatients}/me`,
      }),
    }),
    getPatients: builder.query<User, any>({
      query: () => ({
        headers: customHeaders(),
        method: 'GET',
        url: `${basePathPatients}/me`,
      }),
    }),
    patchPatient: builder.query<User[], any>({
      query: ({ body, uuid }) => ({
        body: JSON.stringify(body),
        headers: {
          ...authPatch(),
          ...{
            'Content-Type': 'application/merge-patch+json',
          },
        },
        method: 'PATCH',
        url: `${basePathPatients}/${uuid}`,
      }),
    }),
    postPartnerResetPassword: builder.mutation<any, any>({
      query: ({ redirectUrl, username }) => ({
        body: {
          redirectUrl,
          username,
        },
        headers: {
          Accept: 'application/json',
          'Accept-Language': getCurrentLocale().code.slice(0, 2),
          'Content-Type': 'application/json',
        },
        method: 'POST',
        url: `${basePathPatients}/request_reset_password`,
      }),
    }),

  }),
  reducerPath: 'patientsApi',
})

export const useGetPatients = patientsApi.endpoints.getPatients.useLazyQuery
export const usePatchPatients = patientsApi.endpoints.patchPatient.useLazyQuery
export const usePostPartnerResetPassword = patientsApi.endpoints.postPartnerResetPassword.useMutation
export const useDeletePatient = patientsApi.endpoints.deletePatients.useLazyQuery
